import { format } from 'date-fns';

/**
 * Formats a date to a human-readable string indicating how long ago it was last modified.
 *
 * @param date - The date to format, typically the last modified date of an item.
 * @returns A string representing the time elapsed since the date, such as "just now", "5 minutes ago", or "on Jan 1, 2023".
 */
export default function formatLastModified(date: Date): string {
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  const pluralize = (value: number, unit: string) =>
    `${value} ${unit}${value === 1 ? '' : 's'} ago`;

  if (seconds < 10) return 'just now';
  if (seconds < 60) return pluralize(seconds, 'second');

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return pluralize(minutes, 'minute');

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return pluralize(hours, 'hour');

  const days = Math.floor(hours / 24);
  if (days < 7) return pluralize(days, 'day');

  const formatStr =
    now.getFullYear() === date.getFullYear() ? 'MMM d' : 'MMM d, yyyy';
  return `on ${format(date, formatStr)}`;
}
